export const PATIENT_ACTIVE_PRODUCTS_OPTIONS = {
  ACTIVE_PRODUCTS: "Patient.HearingAids.ActiveProducts",
  ACTIVE_PRODUCTS_WITH_STATUS: "Patient.HearingAids.ActiveProductsWithStatus",
  ACTIVE_PRODUCTS_SHORT_DESCRIPTION:
    "Patient.HearingAids.ActiveProductsShortDescription",
  LEFT_MANUFACTURER: "Patient.HearingAids.Left.ManufacturerName",
  LEFT_MODEL: "Patient.HearingAids.Left.ModelName",
  LEFT_SERIAL_NUMBER: "Patient.HearingAids.Left.SerialNumber",

  RIGHT_MANUFACTURER: "Patient.HearingAids.Right.Manufacturer",
  RIGHT_MODEL: "Patient.HearingAids.Right.Model",
  RIGHT_SERIAL_NUMBER: "Patient.HearingAids.Right.SerialNumber",

  LEFT_TRIAL_DATE_EXP: "Patient.HearingAids.Left.TrialDateExp",
  RIGHT_TRIAL_DATE_EXP: "Patient.HearingAids.Right.TrialDateExp",
  LEFT_REPAIR_WARRANTY_EXP: "Patient.HearingAids.Left.RepairWarrantyExp",
  RIGHT_REPAIR_WARRANTY_EXP: "Patient.HearingAids.Right.RepairWarrantyExp",
  LEFT_LAND_WARRANTY_EXP: "Patient.HearingAids.Left.LandWarrantyExp",
  RIGHT_LAND_WARRANTY_EXP: "Patient.HearingAids.Right.LandWarrantyExp",
  LEFT_EXTENDED_WARRANTY_EXP: "Patient.HearingAids.Left.ExtendedWarrantyExp",
  RIGHT_EXTENDED_WARRANTY_EXP: "Patient.HearingAids.Right.ExtendedWarrantyExp",

  LEFT_SERVICE_PLAN_EXP: "Patient.HearingAids.Left.ServicePlanExp",
  RIGHT_SERVICE_PLAN_EXP: "Patient.HearingAids.Right.ServicePlanExp",
  LEFT_LAND_COST: "Patient.HearingAids.Left.LandCost",
  RIGHT_LAND_COST: "Patient.HearingAids.Right.LandCost",
  LEFT_DEVICE_COLOR: "Patient.HearingAids.Left.DeviceColor",
  RIGHT_DEVICE_COLOR: "Patient.HearingAids.Right.DeviceColor",
  //
  ACTIVE_PRODUCTS_WITH_WARRANTIES: "Patient.ActiveProducts.WithWarranties",

  // Delivery Date (Fitting Date)
  LEFT_DELIVERY_DATE: "Patient.HearingAids.Left.DeliveryDate",
  RIGHT_DELIVERY_DATE: "Patient.HearingAids.Right.DeliveryDate",
  DELIVERY_DATE: "Patient.HearingAids.DeliveryDate",

  // Fit Date — alias of Delivery Date (same delivered_at); clinics request the "Fit Date" term (ENG-1295)
  LEFT_FIT_DATE: "Patient.HearingAids.Left.FitDate",
  RIGHT_FIT_DATE: "Patient.HearingAids.Right.FitDate"
};

export const PATIENT_ACTIVE_PRODUCTS_MENU_OPTIONS = {
  title: "Patient - Active Products",
  menu: [
    {
      title: "Patient - Active Products - With Warranties",
      value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.ACTIVE_PRODUCTS_WITH_WARRANTIES
    },
    {
      title: "Patient - Active Products - With Status",
      value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.ACTIVE_PRODUCTS_WITH_STATUS
    },
    {
      title: "Patient - Active Products",
      value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.ACTIVE_PRODUCTS
    },
    {
      title: "Patient - Active Products - Short Description",
      value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.ACTIVE_PRODUCTS_SHORT_DESCRIPTION
    },

    {
      title: "Hearing Aids",
      menu: [
        {
          title: "Left",
          menu: [
            {
              title:
                "Patient - Active Products - Hearing Aids - Left - Manufacturer",
              value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.LEFT_MANUFACTURER
            },
            {
              title: "Patient - Active Products - Hearing Aids - Left - Model",
              value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.LEFT_MODEL
            },
            {
              title:
                "Patient - Active Products - Hearing Aids - Left - Serial Number",
              value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.LEFT_SERIAL_NUMBER
            },
            {
              title:
                "Patient - Active Products - Hearing Aids - Left - Trial Date Exp",
              value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.LEFT_TRIAL_DATE_EXP
            },
            {
              title:
                "Patient - Active Products - Hearing Aids - Left - Repair Warranty Exp",
              value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.LEFT_REPAIR_WARRANTY_EXP
            },
            {
              title:
                "Patient - Active Products - Hearing Aids - Left - L&D Warranty Exp",
              value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.LEFT_LAND_WARRANTY_EXP
            },
            {
              title:
                "Patient - Active Products - Hearing Aids - Left - Extended Warranty Exp",
              value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.LEFT_EXTENDED_WARRANTY_EXP
            },
            {
              title:
                "Patient - Active Products - Hearing Aids - Left - Service Plan Exp Date",
              value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.LEFT_SERVICE_PLAN_EXP
            },
            {
              title:
                "Patient - Active Products - Hearing Aids - Left - L&D Cost",
              value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.LEFT_LAND_COST
            },
            {
              title:
                "Patient - Active Products - Hearing Aids - Left - Device Color",
              value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.LEFT_DEVICE_COLOR
            },
            {
              title:
                "Patient - Active Products - Hearing Aids - Left - Delivery Date",
              value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.LEFT_DELIVERY_DATE
            },
            {
              title:
                "Patient - Active Products - Hearing Aids - Left - Fit Date",
              value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.LEFT_FIT_DATE
            }
          ]
        },
        {
          title: "Right",
          menu: [
            {
              title:
                "Patient - Active Products - Hearing Aids - Right - Manufacturer",
              value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.RIGHT_MANUFACTURER
            },
            {
              title: "Patient - Active Products - Hearing Aids - Right - Model",
              value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.RIGHT_MODEL
            },
            {
              title:
                "Patient - Active Products - Hearing Aids - Right - Serial Number",
              value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.RIGHT_SERIAL_NUMBER
            },
            {
              title:
                "Patient - Active Products - Hearing Aids - Right - Trial Date Exp",
              value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.RIGHT_TRIAL_DATE_EXP
            },
            {
              title:
                "Patient - Active Products - Hearing Aids - Right - Repair Warranty Exp",
              value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.RIGHT_REPAIR_WARRANTY_EXP
            },
            {
              title:
                "Patient - Active Products - Hearing Aids - Right - L&D Warranty Exp",
              value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.RIGHT_LAND_WARRANTY_EXP
            },
            {
              title:
                "Patient - Active Products - Hearing Aids - Right - Extended Warranty Exp",
              value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.RIGHT_EXTENDED_WARRANTY_EXP
            },
            {
              title:
                "Patient - Active Products - Hearing Aids - Right - Service Plan Exp Date",
              value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.RIGHT_SERVICE_PLAN_EXP
            },
            {
              title:
                "Patient - Active Products - Hearing Aids - Right - L&D Cost",
              value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.RIGHT_LAND_COST
            },
            {
              title:
                "Patient - Active Products - Hearing Aids - Right - Device Color",
              value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.RIGHT_DEVICE_COLOR
            },
            {
              title:
                "Patient - Active Products - Hearing Aids - Right - Delivery Date",
              value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.RIGHT_DELIVERY_DATE
            },
            {
              title:
                "Patient - Active Products - Hearing Aids - Right - Fit Date",
              value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.RIGHT_FIT_DATE
            }
          ]
        },
        {
          title:
            "Patient - Active Products - Hearing Aids - Both - Delivery Date",
          value: PATIENT_ACTIVE_PRODUCTS_OPTIONS.DELIVERY_DATE
        }
      ]
    }
  ]
};
